module.exports = __webpack_public_path__ + "static/media/Background Info.8dd4b734.txt";